export default __webpack_public_path__ + "static/media/moot-court-8.e27c8e02.webp";